// Family Crest Studio configuration: options, palettes and starter presets.

export const SHAPES = [
  { id: "classic", label: "Classic Shield" },
  { id: "soft", label: "Soft Shield" },
  { id: "round", label: "Round Seal" },
  { id: "diamond", label: "Diamond Shield" },
  { id: "heart", label: "Heart Shield" },
];

export const SYMBOLS = [
  { id: "tree", label: "Tree of Life" },
  { id: "lion", label: "Lion" },
  { id: "crown", label: "Crown" },
  { id: "eagle", label: "Eagle" },
  { id: "fleur_de_lis", label: "Fleur-de-lis" },
  { id: "castle", label: "Castle" },
  { id: "star", label: "North Star" },
  { id: "cross", label: "Heritage Cross" },
  { id: "anchor", label: "Anchor" },
  { id: "oak_leaf", label: "Oak Leaf" },
  { id: "dove", label: "Dove" },
  { id: "compass", label: "Compass" },
];

export const SIGILS = [
  { id: "", label: "None" },
  { id: "star", label: "Star" },
  { id: "crown", label: "Crown" },
  { id: "tree", label: "Tree" },
  { id: "anchor", label: "Anchor" },
  { id: "oak_leaf", label: "Oak Leaf" },
  { id: "dove", label: "Dove" },
  { id: "compass", label: "Compass" },
  { id: "fleur_de_lis", label: "Fleur" },
];

// Heraldic meaning of each personal sigil, shown in the on-tree legend.
export const SIGIL_MEANINGS = {
  star: "Guidance & hope — a guiding light for the family.",
  crown: "Leadership & honour — an elder or head of the family.",
  tree: "Roots & growth — a keeper of family heritage.",
  anchor: "Steadfastness & hope — a steady, dependable soul.",
  oak_leaf: "Strength & endurance — resilient through the seasons.",
  dove: "Peace & love — a gentle, loving presence.",
  compass: "Direction & purpose — a trailblazer and guide.",
  fleur_de_lis: "Purity & nobility — grace passed through generations.",
  lion: "Courage & valour.",
  eagle: "Vision & freedom.",
  castle: "Safety & home.",
  cross: "Faith & remembrance.",
};

export const BANNERS = [
  { id: "classic", label: "Classic Ribbon" },
  { id: "straight", label: "Straight Banner" },
  { id: "folded", label: "Folded Banner" },
  { id: "ribbon", label: "Curved Ribbon" },
];

export const FOLIAGE = [
  { id: "laurel", label: "Laurel" },
  { id: "olive", label: "Olive Branch" },
  { id: "floral", label: "Floral" },
  { id: "none", label: "None" },
];

export const CREST_PLACEMENTS = [
  { id: "top", label: "Top" },
  { id: "bottom_left", label: "Bottom Left" },
  { id: "right", label: "Right Side" },
  { id: "hidden", label: "Hidden" },
];

export const COLOR_FIELDS = [
  { key: "primaryColor", label: "Primary", def: "#071B33" },
  { key: "secondaryColor", label: "Secondary", def: "#F8F0DE" },
  { key: "accentColor", label: "Accent", def: "#D4AF5A" },
  { key: "foliageColor", label: "Foliage", def: "#5D6B36" },
  { key: "bannerTextColor", label: "Banner text", def: "#D4AF5A" },
  { key: "mottoTextColor", label: "Motto text", def: "#071B33" },
];

export const PALETTES = [
  { id: "classic", name: "Classic Legacy", swatches: ["#071B33", "#D4AF5A", "#5D6B36", "#F8F0DE"],
    apply: { primaryColor: "#071B33", accentColor: "#D4AF5A", foliageColor: "#5D6B36", secondaryColor: "#F8F0DE", bannerTextColor: "#D4AF5A", mottoTextColor: "#071B33" } },
  { id: "royal", name: "Royal", swatches: ["#071B33", "#D4AF5A", "#7A1726", "#FAF3E2"],
    apply: { primaryColor: "#071B33", accentColor: "#D4AF5A", foliageColor: "#7A1726", secondaryColor: "#FAF3E2", bannerTextColor: "#D4AF5A", mottoTextColor: "#071B33" } },
  { id: "silver", name: "Silver Heritage", swatches: ["#071B33", "#D4AF5A", "#B7B7B7", "#FFFFFF"],
    apply: { primaryColor: "#071B33", accentColor: "#D4AF5A", foliageColor: "#B7B7B7", secondaryColor: "#FFFFFF", bannerTextColor: "#D4AF5A", mottoTextColor: "#071B33" } },
  { id: "burgundy", name: "Crowned Burgundy", swatches: ["#7A1726", "#D4AF5A", "#F5E6C8", "#342015"],
    apply: { primaryColor: "#7A1726", accentColor: "#D4AF5A", foliageColor: "#342015", secondaryColor: "#F5E6C8", bannerTextColor: "#D4AF5A", mottoTextColor: "#7A1726" } },
  { id: "heart", name: "Heart & Roots", swatches: ["#5D7049", "#D98C9E", "#C8A15A", "#FFF7E7"],
    apply: { primaryColor: "#5D7049", accentColor: "#C8A15A", foliageColor: "#D98C9E", secondaryColor: "#FFF7E7", bannerTextColor: "#FFF7E7", mottoTextColor: "#5D7049" } },
];

export const CROWNS = [
  { id: "royal_classic", label: "Royal Classic" },
  { id: "modern_regal", label: "Modern Regal" },
  { id: "heritage", label: "Heritage Crown" },
  { id: "noble_crest", label: "Noble Crest" },
  { id: "imperial_arch", label: "Imperial Arch" },
  { id: "laurel", label: "Laurel Crown" },
  { id: "minimal_gold", label: "Minimal Gold" },
  { id: "legacy", label: "Legacy Crown" },
];

export const BANNER_ALIGNS = [
  { id: "left", label: "Left" },
  { id: "center", label: "Center" },
  { id: "right", label: "Right" },
];

const BASE = {
  familyName: "The Cooper Family",
  motto: "Strength. Love. Legacy.",
  establishedYear: "1950",
  subtitle: "", familyOrigin: "", founderName: "",
  fontFamily: "serif",
  bannerTextAlign: "center",
  bannerTextOffsetY: 0,
  crownStyle: "royal_classic",
  showCrown: true, showFoliage: true, showBanner: true, showMotto: true,
  showEstablishedYear: true, showFamilyName: true, doubleShieldBorder: true,
  crestPlacement: "bottom_left", customSymbolUrl: null,
};

export const PRESETS = [
  { id: "classic_tree", name: "Classic Tree Shield", tagline: "Timeless & Traditional",
    crest: { ...BASE, shape: "classic", symbol: "tree", bannerStyle: "classic", foliageStyle: "laurel",
      motto: "Strength. Love. Legacy.",
      primaryColor: "#071B33", secondaryColor: "#F8F0DE", accentColor: "#D4AF5A", foliageColor: "#5D6B36",
      bannerTextColor: "#D4AF5A", mottoTextColor: "#071B33" } },
  { id: "royal_lion", name: "Royal Lion", tagline: "Noble & Majestic",
    crest: { ...BASE, shape: "round", symbol: "lion", bannerStyle: "ribbon", foliageStyle: "laurel",
      motto: "Noble. Strong. United.",
      primaryColor: "#071B33", secondaryColor: "#FAF3E2", accentColor: "#D4AF5A", foliageColor: "#D4AF5A",
      bannerTextColor: "#071B33", mottoTextColor: "#7A1726" } },
  { id: "eagle_diamond", name: "Eagle Diamond", tagline: "Strong & Distinctive",
    crest: { ...BASE, shape: "diamond", symbol: "eagle", bannerStyle: "straight", foliageStyle: "olive",
      showCrown: false, motto: "Freedom. Honor. Legacy.", fontFamily: "sans",
      primaryColor: "#0C2340", secondaryColor: "#FFFFFF", accentColor: "#D4AF5A", foliageColor: "#B7B7B7",
      bannerTextColor: "#0C2340", mottoTextColor: "#0C2340" } },
  { id: "crowned_banner", name: "Crowned Banner", tagline: "Prestige & Honor",
    crest: { ...BASE, shape: "soft", symbol: "crown", bannerStyle: "folded", foliageStyle: "laurel",
      motto: "Faith. Family. Forever.", fontFamily: "blackletter",
      primaryColor: "#7A1726", secondaryColor: "#F5E6C8", accentColor: "#D4AF5A", foliageColor: "#D4AF5A",
      bannerTextColor: "#F5E6C8", mottoTextColor: "#7A1726" } },
  { id: "heart_roots", name: "Heart & Roots", tagline: "Love & Connection",
    crest: { ...BASE, shape: "heart", symbol: "tree", bannerStyle: "ribbon", foliageStyle: "floral",
      showCrown: false, motto: "Love Grows Here.", fontFamily: "script",
      primaryColor: "#5D7049", secondaryColor: "#FFF7E7", accentColor: "#C8A15A", foliageColor: "#D98C9E",
      bannerTextColor: "#5D7049", mottoTextColor: "#5D7049" } },
];
